import * as R from "ramda";
import { BlogQueryParams } from "./Blog.constants";
import { format } from "date-fns";
import { getFormattedDate } from "helpers";
import { createSearchParams } from "react-router-dom";
import { TFilterCategory } from "./Blog.types";

export const constructApiUrlSearchQuery = (
  queryParams: any,
  category: string
): URLSearchParams => {
  const startDate = getFormattedDate(
    R.prop(BlogQueryParams.FromDate, queryParams) as string
  );
  const endDate = getFormattedDate(
    R.prop(BlogQueryParams.ToDate, queryParams) as string
  );

  // url query params that are send to BE
  const params = {
    PageNumber: R.prop(BlogQueryParams.ActivePage, queryParams),
    PageSize: R.prop(BlogQueryParams.PageSize, queryParams),
    CategoryTag: category,
    FromDate: startDate ? format(startDate, "MM/dd/yyyy") : "",
    ToDate: endDate ? format(endDate, "MM/dd/yyyy") : "",
    SortBy: R.prop(BlogQueryParams.SortBy, queryParams),
    SearchTerm: R.prop(BlogQueryParams.SearchTerm, queryParams),
  };

  return createSearchParams({
    ...R.reject(R.anyPass([R.isEmpty, R.isNil]))(params as any),
  } as any);
};

export const isShowAllCategory = (category: TFilterCategory | undefined) =>
  category?.Id === "1";
